module.exports = __webpack_public_path__ + "static/old_mutual_logo-289e5a5034c659e38870588e1e039edd.png";